<template>
  <div class="my-weiper-container" :class="{ 'my-weiper-container-mob': !isPC }">
    <div class="hide">
      <!-- 为了预加载所有图片 -->
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev6/more/xingneng1.png" alt="">
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev6/more/xingneng2.png" alt="">
    </div>
    <div class="title" :class="{ 'title-mob': !isPC }">
      <div class="title-pre">爆发性十足的动感体验与焕然灵动的设计</div>
      <div class="title-main">EV6 GT为您带来舒适的全新体验，以全新姿态掌控生活</div>
    </div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" :class="{ 'swiper-slide-mob': !isPC }" v-for="(item, index) in imgs" :key="index">
          <div class="imgBox">
            <img :src="item.imgPC" alt="" :data-index="index"
              :code-stm="`event, PAGEURL页面, 查看详情${item.imgPC}`">
          </div>
        </div>
      </div>
      <div class="swiper-pagination" :class="{ 'swiper-pagination-mob': !isPC }"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      isShowCover: false,
      swiperCover: null,
      imgs: [
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/more/xingneng1.png',
          imgMob: '',
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/more/xingneng2.png',
          imgMob: '',
        },
      ],
      showCoverBox: false,
      isShowVideo: false,
      videoSrc: "",
    };
  },
  mounted: function () {
    let that = this;
    let preIndex = 3;
    this.$nextTick(() => {
      var swiper = new Swiper('.swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '#swiper-button-next',
          prevEl: '#swiper-button-prev',
        },
      });
      // if (this.isPC) {
      //   var swiper = new Swiper('.swiper-container', {
      //     slidesPerView: 3,
      //     spaceBetween: 32,
      //     centeredSlides: true,
      //     loop: true,
      //     observer: true,
      //     pagination: {
      //       el: '.swiper-pagination',
      //       type: 'bullets',
      //       clickable: true,
      //     },
      //     on: {
      //       slideChange: function () {
      //         // console.log('改变了，activeIndex为'+this.activeIndex);
      //         const len = that.imgs.length
      //         that.imgs.forEach((item, index) => {
      //           item.img = item.imgNomal
      //         });
      //         if (this.activeIndex >= 3) {
      //           that.imgs[(this.activeIndex - 3) % len].img = that.imgs[(this.activeIndex - 3) % len].imgActive
      //           // console.log(that.imgs[(this.activeIndex-3)%5].img);
      //           // console.log(that.imgs[(this.activeIndex-3)%5].imgNomal);
      //         }
      //         if (this.activeIndex == 7 && this.activeIndex > preIndex) {
      //           swiper.slideTo(3, 0)
      //         } else if (this.activeIndex == 2 && this.activeIndex < preIndex) {
      //           swiper.slideTo(this.activeIndex + len, 0)
      //         }
      //         // console.log(preIndex);
      //         preIndex = this.activeIndex
      //       },
      //     },
      //     mousewheel: false
      //   });
      // } else {

      // }
    })
  },
  methods: {
    showCover(e) {
      const index = e.target.getAttribute('data-index')
      // console.log(index);
      if (index) {
        this.isShowCover = true
        this.$nextTick(() => {
          this.swiperCover = new Swiper('.swiper-container2', {
            initialSlide: index,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: '.swiper-pagination2',
              type: 'fraction'
            },
            navigation: {
              nextEl: '.swiper-button-next2',
              prevEl: '.swiper-button-prev2',
            },
          });
        })
        // window.removeEventListener("click",this.showCover)

        // window.addEventListener("click",this.showVideo)
      }
    },
    hideCover() {
      this.isShowCover = false
      this.swiperCover = null
      window.addEventListener("click", this.showCover)
      window.removeEventListener("click", this.showVideo)
      this.hideVideo()
    },

    showVideo(e) {
      const index = e.target.getAttribute('data-pop-index')
      // console.log(index);
      if (this.imgs[index].video) {
        this.videoSrc = this.imgs[index].video
        this.isShowVideo = true
      }
    },
    hideVideo() {
      this.videoSrc = ""
      this.isShowVideo = false
    }
  },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.css";

.my-weiper-container {
  position: relative;
  height: 100%;
  width: 100%;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #05141F;

  .hide {
    position: absolute;
    top: -999px;
    left: -999px;
    opacity: 0;
  }

  .title {
    text-align: center;
    margin-top: 4.8958vw;
    margin-bottom: 2.5vw;
    color: #05141F;

    &-mob {
      margin-top: 96px;
      margin-bottom: 32px;
    }

    &-pre {
      font-size: 1.25vw;
      margin-bottom: 1.25vw;
      opacity: 0.8;
    }

    &-main {
      font-size: 2.5vw;
      font-family: chuhei;
    }
  }

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    height: auto;
  }

  .swiper-container {
    position: relative;
    width: 100%;
    height: auto;
    padding-bottom: 45px;
  }

  @media (max-width: 768px) {
    .title {
      padding: 0 25px;

      &-pre {
        font-size: 16px;
        margin-bottom: 12px;
      }

      &-main {
        font-size: 24px;
      }
    }

    .swiper-container {
      width: 100%;
      height: 120vw;

      .swiper-slide-active,
      .swiper-slide {
        transform: scale(1);
      }

      .swiper-slide-active,
      .swiper-slide-duplicate-active {
        transform: scale(1);

        .imgBox {
          padding-top: 0;
        }

        .text {
          display: block;
        }
      }
    }

    .imgBox {
      height: 65vw;
      img {
        height: 100%;
      }
    }
  }

  .swiper-slide {
    cursor: pointer;
    transition: all 300ms;

    .title {
      font-family: chuhei;
      font-size: 1.25vw;
      color: #05141F;
      line-height: 1.875vw;
      width: 100%;
      text-align: center;
      margin: 1.041vw 0 0.833vw;
      white-space: pre-line;
      text-align: left;
    }

    .text {
      text-align: left;
      display: none;
      font-size: 0.9375vw;
      color: rgba(5, 20, 31, 0.8);
      line-height: 1.4583vw;
    }

    .imgBox {
      width: 100%;
      position: relative;

      .coverBox {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.6);
      }

      &:hover {
        .coverBox {
          opacity: 0;
        }
      }
    }

    &-mob {
      transform: scale(1);
    }
  }

  .swiper-slide-active,
  .swiper-slide {
    transform: scale(1);
  }

  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1);
  }

  .swiper-container-horizontal>.swiper-pagination-progressbar,
  .swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    top: unset;
    height: 2px;
    bottom: 0;
  }

  ::v-deep .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #05141f !important;
  }

  ::v-deep .swiper-container-horizontal>.swiper-pagination-bullets {
    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      border: 1px solid #fff;
      background: rgba($color: #000, $alpha: 0);
      border-radius: 50%;
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      width: 12px;
      height: 12px;
      opacity: 1;
      background: #fff;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    width: 2.91666vw;
    height: 2.91666vw;
    background: rgba($color: #fff, $alpha: 0.8);
    transition: all .5s;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    transform: translateY(-50%);

    &::after {
      /* content: none; */
      font-size: 16px;
      font-weight: 900;
      color: rgba(5, 20, 31, 0.8);
    }

    &:hover {
      background: rgba($color: #05141F, $alpha: 0.8);
    }

    &:hover::after {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .swiper-button-prev,
  .swiper-button-next:focus {
    outline: none;
  }

  .swiper-button-next {
    right: 2%;
  }

  .swiper-button-prev {
    left: 2%;
  }

  &-mob {
    padding: 0;

    .swiper-slide {
      .title {
        font-size: 18px;
        line-height: 26px;
        padding: 0 20px;
        margin-top: 24px;
      }

      .text {
        padding: 0 20px;
        font-size: 16px;
        line-height: 24px;
      }
    }

    ::v-deep .swiper-container-horizontal>.swiper-pagination-bullets {
      .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        border: 1px solid #05141F;
        background: #fff;
      }
      .swiper-pagination-bullet-active {
        background: #05141F;
      }
    }

    .swiper-button-mob {
      width: 30px;
      height: 30px;
      background: rgba($color: #000000, $alpha: 0);
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      top: calc(50% - 30px);
      transform: translateY(0);

      &::after {
        font-size: 16px;
        font-weight: 900;
        color: #fff;
      }

      &:hover {
        background: rgba($color: #000000, $alpha: 0);
      }

      &:hover::after {
        color: #fff;
      }
    }
  }

  /* @media screen and (orientation: portrait) {
    padding: 20px 0 25px;
    .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: -20px;
    }
  } */

  .cover {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #000000;
    z-index: 10;

    .el-icon-close {
      color: #fff;
      font-size: 40px;
      cursor: pointer;
      position: absolute;
      z-index: 99;
      right: 50px;
      top: 50px;

      &-mob {
        font-size: 30px;
        right: 20px;
      }
    }

    .pop {
      position: relative;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .pop-video {
      width: 60%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      &-mob {
        width: 100%;
      }

      video {
        width: 100%;
      }
    }

    .swiper-container2 {
      width: 70vw;
      height: auto;
      overflow: hidden;

      .swiper-slide {
        background: rgba($color: #000000, $alpha: 0);

        img {
          width: 78%;
          height: auto;
        }

        @media (max-width: 768px) {
          img {
            width: 100%;
          }
        }

        .icon-play {
          width: 5% !important;
        }

        @media (max-width: 768px) {
          .icon-play {
            width: 10% !important;
          }
        }
      }

      &-mob {
        width: 100vw;
      }
    }

    .swiper-pagination-fraction {
      position: absolute;
      z-index: 999;
      bottom: -30px;
      color: #fff;
    }

    .swiper-button-next,
    .swiper-button-prev {
      background: rgba($color: #000, $alpha: 0);
      transition: all .5s;
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      transform: translateY(-50%);

      &::after {
        /* content: none; */
        font-size: 30px;
        font-weight: 400;
        color: #fff;
      }

      &:hover {
        background: rgba($color: #05141F, $alpha: 0);
      }

      &:hover::after {
        color: #fff;
      }
    }

    .swiper-button-prev,
    .swiper-button-next:focus {
      outline: none;
    }

    .swiper-button-next2 {
      right: 0;
      transform: translateY(-25%);
    }

    .swiper-button-prev2 {
      left: 0;
      transform: translateY(-25%);
    }

    @media (max-width: 768px) {
      .swiper-button-next2 {
        width: auto;
        height: auto;
        right: 2%;
        transform: translateY(25%);
      }

      .swiper-button-prev2 {
        width: auto;
        height: auto;
        left: 2%;
        transform: translateY(25%);
      }
    }
  }
}</style>
